module.exports = __webpack_public_path__ + "img/usa-external-causes-male.5edf7317.png";